import {StyleSheet} from 'aphrodite/no-important';

/* https://www.w3schools.com/howto/howto_css_modals.asp */
export const styles = StyleSheet.create({
    p: {
        fontWeight: 'bold',
        minHeight: '400px'
    }
});



// WEBPACK FOOTER //
// ./react-app-src/sitewideModal/styles/SitewideModalStyles.js